$(function () {

    let animate = getCookie("animate");
    if (animate !== "0") {
        animateElements();

        let animating = false;
        $(window).on("scroll", function () {
            if (!animating) {
                window.requestAnimationFrame(function () {
                    animateElements();
                    animating = false;
                });
                animating = true;
            }
        });

        function animateElements() {
            $(".ar-block-page .ar-animation").each(function (index, element) {
                if (isInView(element)) {
                    $(element).addClass("ar-animation__active");
                } else {
                    $(element).removeClass("ar-animation__active");
                }
            });

            $(".ar-block-page svg:not(.ar-animation__active)").each(function (index, element) {
                if (isInView(element)) {
                    $(element).addClass("ar-animation__active");
                }
            });

            $(".ar-block-page .fact-macro__fact:not(.ar-animation__active, .ar-animation__suppress)").each(function (index, element) {
                if (isInView(element)) {
                    let matched = element.innerHTML.match(/[\d,\.]+/);

                    if (matched) {
                        let number = matched.toString();
                        let decimalPlaces = 0;
                        let matchedDecimalPlaces = number.match(/\.[\d]+/);
                        if (matchedDecimalPlaces) {
                            decimalPlaces = matchedDecimalPlaces[0].length - 1;
                        }

                        let separator = "";
                        if (number.match(/[,]+/)) {
                            separator = ",";
                        }

                        let index = element.innerHTML.indexOf(number);
                        let prefix = element.innerHTML.substring(0, index);
                        let suffix = element.innerHTML.substring(index + number.length);

                        let options = {
                            decimalPlaces: decimalPlaces,
                            separator: separator,
                            prefix: prefix,
                            suffix: suffix,
                        };

                        let counter = new CountUp(element, number.replace(",", ""), options);
                        if (!counter.error) {
                            counter.start();
                        } else {
                            console.error(counter.error);
                        }

                        element.classList.add("ar-animation__active");
                    }
                }
            });

            $(".ar-block-page [data-count-number]:not(.ar-animation__active)").each(function (index, element) {
                element.innerHTML = "";
                if (isInView(element)) {
                    let number = element.getAttribute("data-count-number");
                    let repeat = element.getAttribute("data-count-repeat");
                    let format = element.getAttribute("data-count-format");
                    let rate = element.getAttribute("data-count-rate");

                    let numberCounter = 0;
                    let repeatCounter = 0;
                    let interval = setInterval(function () {

                        numberCounter++;
                        if (numberCounter >= 10) {
                            numberCounter = 0;
                            repeatCounter++;
                        }

                        if (format)
                            element.innerHTML = format.replace("d", numberCounter);
                        else
                            element.innerHTML = numberCounter;

                        if (repeatCounter >= repeat && numberCounter >= number)
                            clearInterval(interval);

                    }, 100 * rate);

                    element.classList.add("ar-animation__active");
                }
            });
        }
    }

    function isInView(element) {
        let position = element.getBoundingClientRect();
        let middle = position.top + ((position.bottom - position.top) / 2);
        return (middle > 0 && middle < window.innerHeight);
    }    
});